<template>
  <div class="element-box">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ElementBox",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.element-box {
  width: 100%;
  &.-center {
    text-align: center;
    margin-right: auto;
    margin-left: auto;
  }
}
</style>
